import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import fetchApi from '../../../utils/api/fetchApi';
import systematic from '../../../config/systematic';
import { Col, Form, Input, Row } from 'antd';
import AntdNotification from '../../../utils/extend/AntdNotification';
import stringHandle from '../../../utilsTs/baseLib/stringHandle';

const SendMessage = (props: any) => {
    const { data, onClose } = props;
    const { serviceName, smsServiceId, templateContent } = data;
    const [form] = Form.useForm(); //form 
    /** 后端数据defaultService */
    const defaultService = systematic.businessService;
    if (typeof templateContent !== 'undefined') {
        const getJson = stringHandle.extractVariablesToJson(templateContent);
        if (getJson.success === true) {
            form.setFieldValue('contents', getJson.data);
        }
    }
    /**
    * 发送信息
    * @param currentId 
    * @returns 
    */
    const sendMessage = async () => {
        const rtn = await fetchApi.POST(defaultService, {
            apiId: 'message',
            apiExtend: 'send',
            apiData: {
                messageType: 'sms',
                dataContent: {
                    smsServiceId,
                    phoneNumbers: form.getFieldValue('phoneNumbers'),
                    contents: form.getFieldValue('contents'),
                    comeFrom: '系统测试'
                }
            }
        });
        if (rtn.success === true) {
            AntdNotification('success', '发送成功');
        } else {
            AntdNotification('error', `发送失败!${rtn?.message}`);
        }
    };

    const handleOk = (e: any) => {
        sendMessage();
        onClose();
    };

    const handleCancel = (e: any) => {
        onClose();
    }

    return (
        <>
            <AntDraggableModal
                title={`${(data.type === 'NEW' ? '新增' : '编辑')}发送短信 - ${serviceName}`}
                open={true}
                okText='发送'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={600}>
                <Form
                    form={form}
                    name="Edit">
                    <Row gutter={[8, 0]}>

                        <Col span={24}>
                            <Form.Item
                                label="手机号码"
                                name="phoneNumbers"
                                tooltip='可多个手机号码，用[;]或[,]分割，请根据短信服务商要求输入'
                                rules={[{ required: true, message: '手机号码!' }]}
                                initialValue={'13763339165'}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="内容"
                                name="contents"
                                tooltip={templateContent ? `${templateContent}  ====>  例如发送内容：
                                {"appellationName": "陈先生",
                                 "branchStoreName": "惠食佳东风大公馆",
                                 "timeTypeName": "2025-08-14(周四) 晚市18:00",
                                 "roomTypeName": "大厅",
                                 "roomName": "一楼102",
                                 "address": "广东广州越秀区东风东路760号",
                                 "phoneNumber": "020-34382088",
                                 "parkingLot": "东山雅筑，东骏广场"}`: '发送短信的内容'}
                                rules={[{ required: true, message: '内容!' }]}
                                initialValue={'测试'}>
                                <Input.TextArea
                                    placeholder="内容"
                                    rows={8}>
                                </Input.TextArea>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}
export default SendMessage;